import React, { ReactNode } from 'react';
import { IFreelancer } from '../../data_models/freelancer';
import { IEmployer } from '../../data_models/employer';
import { EUserType } from '../../data_models/enums';
import { getEmployerName } from '../../utils/employerUtils';
import { getFreelancerName } from '../../utils/freelancerUtils';
import { DEFAULT_USER_PROFILE } from '../../config/defaultAssetUrls';
import useRouting from '../../hooks/useRouting';
import { ChatNowButton, InviteForTasksButton } from './GhButtons';

type AvatarWithDetailsProps = {
    user: IEmployer | IFreelancer
    title: string
    chatNow?: boolean
    invite?: boolean
};

const AvatarWithDetails: React.FC<AvatarWithDetailsProps> = ({ user, title, chatNow = false, invite = false }) => {

    const isEmployer = 'employerName' in user;

    const { goToUserProfile } = useRouting();

    const name = isEmployer
        ? getEmployerName(user as IEmployer)
        : getFreelancerName(user as IFreelancer);

    const profilePictureUrl = isEmployer
        ? (user as IEmployer).profilePictureUrl || DEFAULT_USER_PROFILE.DEFAULT_EMPLOYER_PROFILE_PICTURE
        : (user as IFreelancer).profilePictureUrl || DEFAULT_USER_PROFILE.DEFAULT_FREELANCER_PROFILE_PICTURE_MALE;

    return (

        <div className="flex items-center">
            <div>
                <img
                    alt=""
                    src={profilePictureUrl}
                    className="inline-block size-9 rounded-full"
                />
            </div>
            <div className="flex flex-row space-x-2 items-center">

                <div className="ml-3 hover:underline cursor-pointer" onClick={() => goToUserProfile(isEmployer ? EUserType.EMPLOYER : EUserType.FREELANCER, user._id!)}>
                    <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">{title}</p>
                    <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">{name}</p>
                </div>
                {chatNow && (
                    <ChatNowButton user={user} />
                )}
                {invite && (
                    <InviteForTasksButton freelancer={user as IFreelancer} />
                )}
            </div>
        </div>

    );
};

export default AvatarWithDetails;